var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.25C6.34614 22.25 1.75 17.6539 1.75 12C1.75 6.34614 6.34614 1.75 12 1.75C17.6539 1.75 22.25 6.34614 22.25 12C22.25 17.6539 17.6539 22.25 12 22.25ZM12 2.25C6.62386 2.25 2.25 6.62386 2.25 12C2.25 17.3761 6.62386 21.75 12 21.75C17.3761 21.75 21.75 17.3761 21.75 12C21.75 6.62386 17.3761 2.25 12 2.25Z",
    stroke: "#95A8C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6074 15.404L15.597 15.3971L15.5862 15.3907L12.4864 13.5408C12.4864 13.5407 12.4863 13.5407 12.4862 13.5407C11.8677 13.171 11.39 12.3244 11.39 11.61V7.51001C11.39 7.37615 11.5062 7.26001 11.64 7.26001C11.7739 7.26001 11.89 7.37615 11.89 7.51001V11.61C11.89 11.9084 12.0065 12.2178 12.1441 12.4597C12.2809 12.7001 12.4869 12.9592 12.746 13.1107L15.8438 14.9594L15.8438 14.9594L15.8481 14.9619C15.9565 15.0251 16.0041 15.1703 15.9318 15.3015C15.8728 15.3913 15.7851 15.43 15.71 15.43C15.6835 15.43 15.6636 15.427 15.6486 15.4228C15.6343 15.4189 15.6211 15.4131 15.6074 15.404Z",
    stroke: "#95A8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.568c11f5209864b5589d51425033905e.svg";
export { ForwardRef as ReactComponent };